import {types} from "../../types/types"

// Estado inicial del reducer
const INITIAL_STATE = {
    contactsMessages: [], // Arreglo de mensajes de contacto
    selectContactMessages: {}, // Mensajes del contacto seleccionado
    infoUnreadMessage: [], // Información sobre los mensajes no leídos
    unreadMessages: 0, // Cantidad de mensajes no leídos
    loading: false, // Indicador de carga
    sending: false // Indicador de envío de mensaje
}

// Reducer para el manejo de mensajes
export const messagesReducer = (state = INITIAL_STATE, action) => {

    const {type, payload} = action;

    switch (type) {

        // Caso especial para la vista de historial de chat que no afecta otras vistas
        case 'LOCAL_CHAT_HISTORY_MESSAGES': {
            // Solo actualiza selectContactMessages sin afectar contactsMessages
            return {
                ...state,
                selectContactMessages: {
                    ...payload,
                    type: 'LOCAL_CHAT_HISTORY_MESSAGES' // Añadimos el tipo para identificarlo
                }
            }
        }

        case types.messagesNewMessage: {
            console.log("messagesNewMessage::payload", payload)
            let {id_contact, _id} = payload
            console.log("messagesNewMessage::id_contact", id_contact)
            console.log("messagesNewMessage::id", _id)
            if (_id === undefined) {
                const chars = '0123456789abcdef';
                _id = '';
                for (let i = 0; i < 24; i++) {
                    const randomIndex = Math.floor(Math.random() * chars.length);
                    _id += chars[randomIndex];
                }
            }
            const normalizedPayload = {
                ...payload,
                _id
            }
            const agentContacts = state.contactsMessages.filter(c => c.id_contact === id_contact)
            console.log("messagesNewMessage::agentContacts", agentContacts)
            let contact = undefined
            if (agentContacts.length === 0) {
                if (state.selectContactMessages.id_contact === id_contact) {
                    contact = state.selectContactMessages
                } else {
                    return state;// Si no existe en contacMessage regresa el state sin modificar
                }
            }
            if (contact === undefined) {
                contact = state.contactsMessages[0]; //Selecciona los mensajes del contact
            }
            console.log("messagesNewMessage::contact", contact)
            if (contact.hasOwnProperty("messages") === false) return state;
            const messages = contact.messages; // Filtrar el arreglo de mensajes
            console.log("messagesNewMessage::messages", messages)

            // Verificar si el mensaje ya existe por ID (_id o id del servidor)
            const messageById = messages.find(m => m._id === _id || (payload.id && m.id === payload.id));

            // Para mensajes sin id de servidor (dispatches locales del agente), verificar
            // por contenido dentro de 30s para evitar doble-render del optimistic update.
            const isDuplicate = !normalizedPayload.id && !normalizedPayload.incoming && messages.some(m => {
                if (m._id === _id) return true;
                if (normalizedPayload.incoming === true) return false;

                if (normalizedPayload.type_message === 'file' && m.type_message === 'file') {
                    const sameFileName = m.name_file === normalizedPayload.name_file;
                    const sameDirection = m.incoming === normalizedPayload.incoming;
                    if (!sameFileName || !sameDirection) return false;
                } else {
                    const sameContent = m.body === normalizedPayload.body;
                    const sameType = m.type_message === normalizedPayload.type_message;
                    const sameDirection = m.incoming === normalizedPayload.incoming;
                    if (!sameContent || !sameType || !sameDirection) return false;
                }

                const messageTime = new Date(normalizedPayload.date_create || Date.now()).getTime();
                const existingMessageTime = new Date(m.date_create || Date.now()).getTime();
                return Math.abs(messageTime - existingMessageTime) < 30000;
            });

            console.log("messagesNewMessage::message", messageById)
            console.log("messagesNewMessage::isDuplicate", isDuplicate)

            // Si el mensaje existe por ID o es un duplicado saliente, no modificar el estado
            if (messageById || isDuplicate) {
                return state // Si el mensaje existe regresa el estado sin cambios
            }

            const newconmsg = {
                ...contact,
                messages: [
                    ...messages,
                        normalizedPayload
                ]
            }
            console.log("messagesNewMessage::newconmsg", newconmsg)

            if (state.selectContactMessages.id_contact === normalizedPayload.id_contact) {
                return {
                    ...state,
                    contactsMessages: [
                        ...state.contactsMessages.filter(cm => cm.id_contact !== id_contact),
                        newconmsg
                    ],
                    selectContactMessages: {...newconmsg}
                }
            }
            return {
                ...state,
                contactsMessages: [
                    ...state.contactsMessages.filter(cm => cm.id_contact !== id_contact),
                    newconmsg
                ]
            }
        }
        case
        types.messageAddFirstContactMessages
        :
            // Acción para agregar los mensajes del primer contacto
            return {
                ...state,
                contactsMessages: [...state.contactsMessages, payload],
                selectContactMessages: {...payload}
            }
        case
        types.messagesAddContactMessages
        : {
            // Acción para agregar mensajes de un contacto
            const index = state.contactsMessages.findIndex(contact => contact.id_contact === payload.id_contact);
            if (index === -1) return state; // Respuesta tardía de load-more para un contacto ya limpiado
            const new_contactsMessages = [...state.contactsMessages];
            new_contactsMessages[index] = {
                ...payload,
                messages: [
                    ...payload.messages,
                    ...new_contactsMessages[index].messages
                ]
            }
            const isCurrentContact = state.selectContactMessages.id_contact === payload.id_contact;
            return {
                ...state,
                contactsMessages: new_contactsMessages,
                selectContactMessages: isCurrentContact
                    ? {
                        ...state.selectContactMessages,
                        ...payload,
                        messages: [
                            ...payload.messages,
                            ...(state.selectContactMessages.messages || [])
                        ]
                    }
                    : state.selectContactMessages
            }
        }
        case
        types.messagesLoading
        :
            // Acción para indicar el estado de carga
            return {
                ...state,
                loading: payload
            }
        case
        types.messagesSetSelectContactMessages
        :
            // Acción para establecer los mensajes del contacto seleccionado
            return {
                ...state,
                selectContactMessages: {...payload}
            }
        case
        types.messageSetContactInfo
        :
            // Acción para establecer la información del contacto
            return {
                ...state,
                selectContactMessages: {...payload}
            }
        case
        types.messageSendigMessage
        :
            // Acción para indicar el estado de envío de mensaje
            return {
                ...state,
                sending: payload
            }
        case
        types.messageUnreadMessages
        : {
            // Acción para marcar mensajes como no leídos
            const {id_contact} = payload;

            const index = state.contactsMessages.findIndex(c => c.id_contact === id_contact); // Busca el índice del objeto con el arreglo de mensajes

            if (index === -1) return state; // Si no existe en contactsMessages, regresa el estado sin modificar

            const contactMessage = {
                ...state.contactsMessages[index],
                messages: [...(state.contactsMessages[index].messages || []), 'new_messages']
            }; // Agrega el marcador 'new_messages'

            if (state.selectContactMessages.id_contact === id_contact) {
                return {
                    ...state,
                    contactsMessages: [
                        ...state.contactsMessages.filter(cm => cm.id_contact !== id_contact),
                        contactMessage
                    ],
                    selectContactMessages: {...contactMessage}
                }
            }

            return {
                ...state,
                contactsMessages: [
                    ...state.contactsMessages.filter(cm => cm.id_contact !== id_contact),
                    contactMessage
                ]
            }
        }
        case
        types.messageReadMessages
        : {
            // Acción para marcar mensajes como leídos
            const {id_contact} = payload;

            const index = state.contactsMessages.findIndex(c => c.id_contact === id_contact); // Busca el índice del objeto con el arreglo de mensajes

            if (index === -1) return state; // Si no existe en contactsMessages, regresa el estado sin modificar

            const contactMessage = state.contactsMessages[index]; // Selecciona los mensajes del contacto

            const new_msg = contactMessage.messages.find(item => item === 'new_messages');

            if (!new_msg) return state;

            const updatedContactMessage = {
                ...contactMessage,
                messages: [...state.contactsMessages[index].messages.filter(cm => cm !== 'new_messages')]
            }; // Quita el marcador 'new_messages'

            if (state.selectContactMessages.id_contact === id_contact) {
                return {
                    ...state,
                    contactsMessages: [
                        ...state.contactsMessages.filter(cm => cm.id_contact !== id_contact),
                        updatedContactMessage
                    ],
                    selectContactMessages: {...updatedContactMessage}
                }
            }

            return {
                ...state,
                contactsMessages: [
                    ...state.contactsMessages.filter(cm => cm.id_contact !== id_contact),
                    updatedContactMessage
                ]
            }
        }
        case types.messageAppendOffsetMessage: {
            const index = state.contactsMessages.findIndex(c => c.id_contact === payload);
            const contactMessages = [...state.contactsMessages];

            // Si no existe en contactsMessages, pero sí es el contacto seleccionado, lo agregamos
            if (index === -1) {
                if (state.selectContactMessages?.id_contact === payload) {
                    const selectOffset = typeof state.selectContactMessages.offset === 'number'
                        ? state.selectContactMessages.offset + 1
                        : 1;

                    const updatedContact = {
                        ...state.selectContactMessages,
                        offset: selectOffset
                    };

                    return {
                        ...state,
                        contactsMessages: [...state.contactsMessages, updatedContact],
                        selectContactMessages: updatedContact
                    };
                }

                // Si no se encuentra en ningún lado, regresamos el estado original
                return state;
            }

            // Si sí existe en contactsMessages
            const currentOffset = typeof contactMessages[index].offset === 'number'
                ? contactMessages[index].offset
                : 0;

            contactMessages[index] = {
                ...contactMessages[index],
                offset: currentOffset + 1
            };

            const updatedSelect =
                payload === state.selectContactMessages?.id_contact
                    ? {
                        ...state.selectContactMessages,
                        offset: typeof state.selectContactMessages.offset === 'number'
                            ? state.selectContactMessages.offset + 1
                            : 1
                    }
                    : state.selectContactMessages;

            return {
                ...state,
                contactsMessages: contactMessages,
                selectContactMessages: updatedSelect
            };
        }

        case types.messageAppendOffsetByMessageId: {
            console.log("messageAppendOffsetByMessageId")
            // Acción para actualizar el offset por ID de mensaje
            const {id_contact, id_message} = payload;

            const index = state.contactsMessages.findIndex(c => c.id_contact === id_contact);
            const contactMessages = [...state.contactsMessages];

            if (index !== -1 && contactMessages[index] && contactMessages[index].messages) {
                const index_msg = contactMessages[index].messages.findIndex(c => c._id === id_message);

                if (index_msg !== -1) {
                    return state;
                }

                contactMessages[index] = {
                    ...contactMessages[index],
                    offset: contactMessages[index].offset + 1
                };

                if (id_contact === state.selectContactMessages.id_contact) {
                    return {
                        ...state,
                        contactsMessages: contactMessages,
                        selectContactMessages: {
                            ...state.selectContactMessages,
                            offset: state.selectContactMessages.offset + 1
                        }
                    };
                }

                return {
                    ...state,
                    contactsMessages: contactMessages
                };
            }
            // Manejo del caso donde `index` es `-1` o `contactMessages[index]` es `undefined`
            console.error('Invalid contact index or messages not found');
            return state;
        }

        case
        types.messageUpdateNotification
        : {
            // Acción para actualizar las notificaciones de mensajes
            const {count, items} = payload;

            return {
                ...state,
                unreadMessages: count,
                infoUnreadMessage: [...items]
            }
        }
        case
        types.messageRemoveNotification
        : {
            // Acción para eliminar una notificación de mensaje
            const contact = state.infoUnreadMessage.find(contact => contact._id === payload);

            if (!contact) return state;

            return {
                ...state,
                unreadMessages: (state.unreadMessages - contact.unread_message),
                infoUnreadMessage: [...state.infoUnreadMessage.filter(c => c._id !== payload)]
            }
        }
        case
        types.messageAddNotification
        : {
            // Acción para agregar una notificación de mensaje
            const contactIndex = state.infoUnreadMessage.findIndex(contact => contact._id === payload._id);

            if (contactIndex !== -1) {
                return {
                    ...state,
                    infoUnreadMessage: [
                        payload,
                        ...state.infoUnreadMessage.filter(c => c._id !== payload._id)
                    ],
                    unreadMessages: (state.unreadMessages + 1)
                };
            }

            return {
                ...state,
                infoUnreadMessage: [
                    payload,
                    ...state.infoUnreadMessage
                ],
                unreadMessages: (state.unreadMessages + 1)
            }
        }
        case
        types.messageClearSelectContactMessages
        : {
            // Acción para limpiar los mensajes del contacto seleccionado
            return {
                ...state,
                selectContactMessages: {}
            }
        }
        case
        types.messageSetSelectContactMessagesByIdContact
        : {
            // Acción para establecer el contacto seleccionado por ID de contacto
            const contact = state.contactsMessages.find(item => item.id_contact === payload);

            return {
                ...state,
                selectContactMessages: contact
            }
        }
        case
        types.messageCleanContactList
        : {
            return {
                ...state,
                contactsMessages: []
            }
        }
        case types.messageUpdateReactions: {
            const {id_contact, id_message, reactions} = payload;

            const updateMessages = (messages) =>
                messages.map((msg) =>
                    msg._id === id_message ? {...msg, reactions} : msg
                );

            const contactsMessages = state.contactsMessages.map((contact) => {
                if (contact.id_contact !== id_contact) return contact;
                return {
                    ...contact,
                    messages: updateMessages(contact.messages || []),
                };
            });

            const selectContactMessages =
                state.selectContactMessages.id_contact === id_contact
                    ? {
                        ...state.selectContactMessages,
                        messages: updateMessages(state.selectContactMessages.messages || []),
                    }
                    : state.selectContactMessages;

            return {
                ...state,
                contactsMessages,
                selectContactMessages,
            };
        }

        default:
            return state;
    }
}
